<template>
  <mia-modal
    id="car-exchange-modal"
    v-bind="$attrs"
    width="60%"
    v-on="$listeners"
  >
    <mia-modal-header title="Inzahlungnahme verknüpfen" />

    <div class="p-4">
      <mia-feature-select
        v-model="mode"
        label="Art der Inzahlungnahme"
      >
        <template #options>
          <option
            value="of"
          >
            Das aktuelle Fahrzeug ist eine Inzahlungnahme für das unten ausgewählte Fahrzeug
          </option>
          <option
            value="for"
          >
            Für das aktuelle Fahrzeug wurde das unten ausgewählte Fahrzeug in Zahlung genommen
          </option>
        </template>
      </mia-feature-select>

      <div class="mt-4">
        <mia-feature-label
          :text="mode === 'of' ? 'Fahrzeug, für dass das aktuelle Fahrzeug in Zahlung genommen wurde' : 'Fahrzeug, welches in Zahlung genommen wurde'"
          for="exchange-car"
        />
        <mia-car-exchange-select
          id="exchange-car"
          v-model="car"
        />
      </div>

      <div class="mt-4">
        <router-link :to="`/legacy/car_add/${currentCar.id}`">
          Möchten Sie stattdessen ein neues Fahrzeug als Inzahlungnahme anlegen?
        </router-link>
      </div>
    </div>

    <mia-modal-footer class="flex justify-end space-x-3">
      <mia-cancel-button
        :disabled="$wait.any"
        @click="$emit('closed')"
      />
      <mia-submit-button
        type="button"
        :disabled="$wait.any || !car"
        :is-loading="$wait.is('saving exchange')"
        label="Inzahlungnahme verknüpfen"
        @click="save"
      />
    </mia-modal-footer>
  </mia-modal>
</template>

<script>
import { saveExchange } from '@/api/cars'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import FeatureLabel from '@/components/cars/edit/FeatureLabel.vue'
import CarExchangeSelect from '@/components/ui/inputs/CarExchangeSelect.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'

export default {
  name: 'MiaExchangeModal',

  components: {
    'mia-cancel-button': CancelButton,
    'mia-submit-button': SubmitButton,
    'mia-car-exchange-select': CarExchangeSelect,
    'mia-feature-label': FeatureLabel,
    'mia-feature-select': FeatureSelect
  },

  props: {
    carId: {
      type: [String, Number],
      required: true
    }
  },

  data: () => ({
    mode: 'of',
    car: ''
  }),

  computed: {
    currentCar() {
      return this.$store.state.car.car
    }
  },

  methods: {
    async save() {
      this.$wait.start('saving exchange')
      const [errors] = await saveExchange(this.carId, { carId: this.car, mode: this.mode })
      this.$wait.end('saving exchange')

      if (errors) {
        window.eventBus.$emit('mia-error', {
          error: ['Die Inzahlungnahme konnte nicht gespeichert werden.']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Die Inzahlungnahme wurde erfolgreich gespeichert.']
      })
      this.$emit('done')
    }
  }
}
</script>

<style lang="scss">
.v--modal-overlay .v--modal-box {
  overflow: visible !important;
}
</style>
